import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Api } from 'src/app/services/api';
import { Globals } from 'src/app/services/globals';
import { IPoster } from '../../../../../../../common/common-interfaces/poster';
import { clothesSKUsByCategory, productNamesBySKU } from '../../../../../../../common/common-helpers/sku';

@Component({
    selector: 'product-overview',
    templateUrl: './product-overview.component.html',
    styleUrls: ['./product-overview.component.scss'],
    standalone: false
})
export class ProductOverviewComponent {
  availableClothes: any = {}
  productNamesBySKU = productNamesBySKU;
  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals) {

  }

  async ngOnInit() {
    for (let category in clothesSKUsByCategory) {
      if (!this.availableClothes[category])
        this.availableClothes[category] = Object.values(clothesSKUsByCategory[category].map(sku => {
          let skuSplit = sku.split('-');
          let productNameSplit = this.productNamesBySKU[sku].split(' - ');
          productNameSplit.pop();
          return {
            model: skuSplit[0],
            color: skuSplit[1],
            sku: sku,
            name: productNameSplit.join(', ').trim()
          }
        }).reduce((data, current) => {
          if (!data[`${current.model}-${current.color}`])
            data[`${current.model}-${current.color}`] = current;
          return data;
        }, {} as any));
    }

  }
}


